module.exports = __webpack_public_path__ + "static/logo-oncology-395006eeb94274b9657c6429c00dfe39.png";